(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[237],{

/***/ 6528:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tool/map",
      function () {
        return __webpack_require__(8828);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SafeHtmlSpan */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_sanitize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2938);



var SafeHtmlSpan = function(param) {
    var html = param.html;
    if (typeof html !== "string") return html;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        dangerouslySetInnerHTML: {
            __html: (0,_utils_sanitize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(html)
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafeHtmlSpan);


/***/ }),

/***/ 8828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ map; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-head-seo/dist/index.module.js
var index_module = __webpack_require__(4058);
// EXTERNAL MODULE: ./config/index.ts + 1 modules
var config = __webpack_require__(5740);
// EXTERNAL MODULE: ./components/tools/map/Layout.tsx + 26 modules
var Layout = __webpack_require__(9643);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/styled/Button.tsx
var Button = __webpack_require__(5301);
// EXTERNAL MODULE: ./components/ui/SafeHtmlDiv.tsx
var SafeHtmlDiv = __webpack_require__(3427);
// EXTERNAL MODULE: ./components/ui/SafeHtmlSpan.tsx
var SafeHtmlSpan = __webpack_require__(54);
// EXTERNAL MODULE: ./components/tools/shared/ui/Box.tsx
var Box = __webpack_require__(8695);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./components/tools/shared/ui/Icon.tsx
var Icon = __webpack_require__(7205);
// EXTERNAL MODULE: ./components/tools/map/state/ToolState.tsx
var ToolState = __webpack_require__(8656);
;// CONCATENATED MODULE: ./components/tools/map/Contribute.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  pointer-events: all;\n\n  & * {\n    color: var(--color-piai-map-highlight);\n  }\n\n  h3 {\n    font-size: 1.1em;\n    display: flex;\n    justify-content: space-between;\n\n    .svg{\n      min-width: var(--size-4);\n\n      ",
        " {\n        min-width: var(--size-3);\n      }\n\n    }\n  }\n\n  a {\n    color: var(--color-piai-map-highlight);\n    border-color: var(--color-piai-map-highlight);\n    align-self: end;\n    margin-right: 0;\n    &:hover {\n      margin-right: -0.3em;\n    }\n    &:visited, &:link {\n      color: var(--color-piai-map-highlight);\n    }\n  }\n\n  ",
        " {\n    max-width: calc((100vw - var(--size-6) - 2 * var(--size-3)) * 0.666);\n  }\n\n  ",
        " {\n    max-width: calc((100vw - var(--size-6) - 3 * var(--size-3)) * 0.333);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var ContributeBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* Box */.x).withConfig({
    componentId: "sc-4ebab100-0"
})(_templateObject(), function(param) {
    var seen = param.seen;
    return seen && "display: none;";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.mobileLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
});
var Contribute = function(param) {
    var position = param.position;
    var mapState = (0,ToolState/* useToolStateMapState */.e1)();
    var updateMapState = (0,ToolState/* useToolStateStoreActions */.cH)().updateMapState;
    var cta = {
        title: "Contribute",
        text: "<p>There is a lack of accumulated and detailed data on public interest AI projects, including their specific objectives, methods, and frameworks. This is why we created a survey.</p><p>Contribute by filling out the online survey and include your project in this interactive map and directory.</p>",
        url: "/tool/map/survey",
        linkTitle: "Add your project"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContributeBox, {
        className: "cta",
        seen: mapState.hideIntro,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlSpan/* default */.Z, {
                        html: cta.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        active: true,
                        type: "close",
                        onClick: function() {
                            return updateMapState({
                                hideIntro: true
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlDiv/* default */.Z, {
                html: cta.text
            }),
            (cta === null || cta === void 0 ? void 0 : cta.url) && (cta === null || cta === void 0 ? void 0 : cta.linkTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: cta === null || cta === void 0 ? void 0 : cta.url,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButtonAnimated */.kz, {
                    children: cta === null || cta === void 0 ? void 0 : cta.linkTitle
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/tool/map/index.tsx

function map_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n  gap: var(--size-3);\n\n  padding: var(--size-3);\n  padding-bottom: calc(var(--size-6) + 2 * var(--size-3));\n\n  ",
        " {\n    padding: var(--size-3);\n    padding-bottom: calc(2 * var(--size-3) + var(--size-5));\n  }\n\n  ",
        " {\n    padding: var(--size-3);\n  }\n\n  ",
        " {\n    padding: var(--size-6) var(--size-3) calc(var(--size-3)) var(--size-3);\n  }\n"
    ]);
    map_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57d0cba7-0"
})(map_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.desktop;
});
var Index = function(param) {
    var frontendSettings = param.frontendSettings, tool = param.tool;
    var ref;
    var currentTool = (ref = config/* appConfig.tools */.e.tools) === null || ref === void 0 ? void 0 : ref.find(function(t) {
        return t.slug === "map";
    });
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* default */.Z, {
                title: "".concat((currentTool === null || currentTool === void 0 ? void 0 : currentTool.name) ? "".concat(currentTool === null || currentTool === void 0 ? void 0 : currentTool.name, " - ") : "", " ").concat(config/* appConfig.appTitle */.e.appTitle),
                description: (ref1 = currentTool === null || currentTool === void 0 ? void 0 : currentTool.description) !== null && ref1 !== void 0 ? ref1 : undefined,
                og: {
                    title: "".concat((currentTool === null || currentTool === void 0 ? void 0 : currentTool.name) ? "".concat(currentTool === null || currentTool === void 0 ? void 0 : currentTool.name, " - ") : "", " ").concat(config/* appConfig.appTitle */.e.appTitle),
                    siteName: config/* appConfig.appTitle */.e.appTitle
                },
                twitter: {
                    card: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Contribute, {
                    position: "bottom"
                })
            })
        ]
    });
};
Index.getLayout = function getLayout(page, props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        props: props,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var map = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [471,619,917,47,643,774,888,179], function() { return __webpack_exec__(6528); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);